import { render, staticRenderFns } from "./view-photo.vue?vue&type=template&id=4cb1ad4d&scoped=true&"
import script from "./view-photo.vue?vue&type=script&lang=js&"
export * from "./view-photo.vue?vue&type=script&lang=js&"
import style0 from "./view-photo.vue?vue&type=style&index=0&id=4cb1ad4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb1ad4d",
  null
  
)

export default component.exports